import { Helmet } from "react-helmet-async";
import { Button, Card, CardBody, Col, Container, Row } from "reactstrap";
import DocumentBuider from "../../components/DocumentBuider/DocumentBuider";
import { documentBuilderVariants } from "../../enums/documentBuiderVariants";
import { useCallback, useEffect, useState } from "react";
import { DOCUMENT_URL, SECTION_URL } from "../../helpers/url_api_helper";

const DocumentBuiderTeste = () => {
  const [contentSection, setContentSection] = useState([]);
  const [initialContentSection, setInitialContentSection] = useState([]);
  const [contentDocument, setContentDocument] = useState([]);
  const [initialContentDocument, setInitialContentDocument] = useState([]);
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      const resSection = await SECTION_URL.getSection(5);
      const resDocument = await DOCUMENT_URL.getDocument(5);
      setInitialContentSection(resSection.content);
      setInitialContentDocument(resDocument.content);
      setLoading(false);
    };

    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleBuilderSectionChange = useCallback((data) => {
    setContentSection(data);
  }, []);

  const handleBuilderDocumentChange = useCallback((data) => {
    setContentDocument(data);
  }, []);

  return (
    <div className="page-content">
      <Helmet>
        <title>Teste Document Buider</title>
      </Helmet>
      <Container fluid>
        <Row>
          <Col xs={12}>
            <Card>
              <CardBody>
                <Row>
                  <Col xs={12}>
                    <DocumentBuider
                      variant={documentBuilderVariants.SECTION}
                      initialSelectedItems={initialContentSection}
                      handleChange={handleBuilderSectionChange}
                      loading={loading}
                    />
                    <Button
                      className="my-3"
                      onClick={() => {
                        alert(JSON.stringify(contentSection));
                      }}
                    >
                      Alert Content Section
                    </Button>
                  </Col>
                  <Col xs={12}>
                    <DocumentBuider
                      variant={documentBuilderVariants.DOCUMENT}
                      initialSelectedItems={initialContentDocument}
                      handleChange={handleBuilderDocumentChange}
                      loading={loading}
                    />
                    <Button
                      className="my-3"
                      onClick={() => {
                        alert(JSON.stringify(contentDocument));
                      }}
                    >
                      Alert Content Document
                    </Button>
                  </Col>
                </Row>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default DocumentBuiderTeste;
